import { LockIcon } from 'components/icons/LockIcon';
import React from 'react';
import { ReactComponent as RingsIcon } from 'assets/img/icons/rings.svg';

interface SelectChannelItemProps {
  key: string;
  name: string;
  handleClick: (e?: any) => void;
  [key: string]: any;
}

const SelectChannelItem = ({ privacy, name, handleClick, is_shared_channel }: SelectChannelItemProps) => {
  return (
    <div
      className="group flex items-center my-1 text-sm leading-[21px] font-bold text-black hover:text-white px-2 py-1 cursor-pointer hover:bg-blue-menu-active"
      role="SelectChannelItem"
      tabIndex={-1}
      id="dropdown-item-0"
      onClick={handleClick}
    >
      <span className="font-commuter font-normal text-sm">#{name}</span>
      {is_shared_channel && <RingsIcon className="w-3 h-3 ml-3 group-hover:fill-white" />}
      {privacy === 'private' && <LockIcon className="w-3 h-3 ml-3 group-hover:fill-white" />}
    </div>
  );
};

export default React.memo(SelectChannelItem);
